import { useEffect, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Usia Hijriah - Hitung Usia Anda dengan Akurat - Perhitungan Usia Hijriah";
const DESCRIPTION =
  "Kalkulator usia Hijriah memungkinkan Anda menghitung usia Hijriah dengan memasukkan tanggal lahir baik dalam tanggal Hijriah maupun Masehi - Gunakan kalkulator usia Hijriah untuk mengkonversi tanggal ke usia yang akurat sesuai kalender Hijriah dan Islam";
const KEYWORDS =
  "perhitungan usia hijriah, kalkulator usia hijriah, konversi tanggal ke usia hijriah, kalkulator usia hijriah, usia hijriah, konversi tanggal ke tahun hijriah, perhitungan usia dalam tanggal hijriah, kalkulator usia profesional hijriah, perhitungan usia akurat dengan hijriah, hijrah ke usia aktual, perhitungan usia seseorang dalam tanggal hijriah, perhitungan usia menurut kalender hijriah";
const OG_URL = "https://do-calculate.com/calculator/id/agehijri/";

// JSON-LD Schema for SEO
const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Kalkulator Usia Hijriah",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Beranda",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Semua Kalkulator",
        item: "https://do-calculate.com/id/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Kalkulator Usia Hijriah",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Apa itu usia Hijriah?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Usia Hijriah adalah cara yang kita gunakan untuk mengukur usia seseorang berdasarkan tanggal lahirnya menurut kalender Hijriah bulanan dan tahunan.",
        },
      },
      {
        "@type": "Question",
        name: "Bagaimana cara menghitung usia Hijriah?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Anda dapat menghitung usia Hijriah dengan memasukkan tanggal lahir Anda ke dalam kalkulator, dan kalkulator akan secara otomatis menghitung usia Anda dalam tahun, bulan, hari, dan jam dengan sangat akurat.",
        },
      },
      {
        "@type": "Question",
        name: "Apa saja kegunaan menghitung usia Hijriah?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Perhitungan usia Hijriah digunakan dalam merenungkan pengalaman hidup, perencanaan masa depan, penetapan tujuan pribadi, serta dalam bidang asuransi, pensiun, dan perawatan kesehatan.",
        },
      },
    ],
  },
];
const DAYS_OF_WEEK = [
  "Minggu",
  "Senin",
  "Selasa",
  "Rabu",
  "Kamis",
  "Jumat",
  "Sabtu",
];
const GREGORIAN_MONTHS = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];
const HIJRI_MONTHS = [
  "Muharram",
  "Safar",
  "Rabiul Awal",
  "Rabiul Akhir",
  "Jumadil Awal",
  "Jumadil Akhir",
  "Rajab",
  "Sya'ban",
  "Ramadhan",
  "Syawal",
  "Dzulqa'dah",
  "Dzulhijjah",
];
const SEASONS = [
  {
    name: "Musim Dingin",
    start: { month: 12, day: 21 },
    end: { month: 3, day: 20 },
  },
  { name: "Musim Semi", start: { month: 3, day: 21 }, end: { month: 6, day: 20 } },
  { name: "Musim Panas", start: { month: 6, day: 21 }, end: { month: 9, day: 22 } },
  {
    name: "Musim Gugur",
    start: { month: 9, day: 23 },
    end: { month: 12, day: 20 },
  },
];
// Helper function to convert Hijri to Gregorian
const hijriToGregorian = (hijriDay, hijriMonth, hijriYear) => {
  // This is a simplified conversion. For production, use a proper library like hijri-converter
  const adjustment = Math.floor(hijriYear * 0.97); // Approximate adjustment factor
  const gregorianYear = hijriYear + 622 - adjustment;
  // Simplified month and day mapping (this is not accurate, just for demonstration)
  // In production, use a proper conversion library
  const monthDays = [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29]; // Hijri months
  let totalDays = 0;
  for (let i = 0; i < hijriMonth - 1; i++) {
    totalDays += monthDays[i];
  }
  totalDays += hijriDay - 1;
  // Convert to Gregorian days (approximate)
  const gregorianDays = Math.floor(totalDays * 1.0307);
  const date = new Date(gregorianYear, 0, 1);
  date.setDate(date.getDate() + gregorianDays);
  return date;
};
// Helper function to get current Hijri year
const getCurrentHijriYear = () => {
  const currentDate = new Date();
  const currentGregorianYear = currentDate.getFullYear();
  // Approximate calculation: Hijri year = (Gregorian year - 622) * 1.03
  return Math.floor((currentGregorianYear - 622) * 1.03);
};
function AgeCalculatorHijri() {
  const [convertedValue, setConvertedValue] = useState("hijri");
  const [dateOfBirthGregorian, setDateOfBirthGregorian] = useState({
    day: "",
    month: "",
    year: ""
  });
  const [dateOfBirthHijri, setDateOfBirthHijri] = useState({
    day: "",
    month: "",
    year: ""
  });
  const [ageResult, setAgeResult] = useState(null);
  const [error, setError] = useState(null);
  const [hijriYears, setHijriYears] = useState([]);
  // Generate Hijri years list
  useEffect(() => {
    const currentHijriYear = getCurrentHijriYear();
    const years = [];
    // Generate years from 1300 to current Hijri year + 10
    for (let year = 1300; year <= currentHijriYear + 10; year++) {
      years.push(year);
    }
    setHijriYears(years);
  }, []);
  const handleConversionValueChange = (newConversionType) => {
    setConvertedValue(newConversionType);
    setError(null);
    setDateOfBirthGregorian({ day: "", month: "", year: "" });
    setDateOfBirthHijri({ day: "", month: "", year: "" });
    setAgeResult(null);
  };
  const calculateAge = (birthDate, isHijri = false) => {
    const today = new Date();
    const birth = new Date(birthDate);
    if (isNaN(birth.getTime()) || birth > today) {
      setError("Harap masukkan tanggal lahir yang valid");
      setAgeResult(null);
      return;
    }
    let years = today.getFullYear() - birth.getFullYear();
    let months = today.getMonth() - birth.getMonth();
    let days = today.getDate() - birth.getDate();
    if (days < 0) {
      months--;
      const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += lastMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }
    const hours = today.getHours() - birth.getHours();
    const minutes = today.getMinutes() - birth.getMinutes();
    const seconds = today.getSeconds() - birth.getSeconds();
    // Calculate total time units
    const totalDays = Math.floor((today - birth) / (1000 * 60 * 60 * 24));
    const totalHours = Math.floor((today - birth) / (1000 * 60 * 60));
    const totalMinutes = Math.floor((today - birth) / (1000 * 60));
    const totalSeconds = Math.floor((today - birth) / 1000);
    const totalWeeks = Math.floor(totalDays / 7);
    const totalMonths = years * 12 + months;
    // Calculate next birthday
    let nextBirthday = new Date(
      today.getFullYear(),
      birth.getMonth(),
      birth.getDate()
    );
    if (nextBirthday < today) {
      nextBirthday.setFullYear(today.getFullYear() + 1);
    }
    const daysUntilBirthday = Math.ceil(
      (nextBirthday - today) / (1000 * 60 * 60 * 24)
    );
    // Get day of week born
    const dayOfWeekBorn = DAYS_OF_WEEK[birth.getDay()];
    // Get birth month in Arabic
    const birthMonthArabic = isHijri
      ? HIJRI_MONTHS[birth.getMonth()]
      : GREGORIAN_MONTHS[birth.getMonth()];
    // Get season born
    const birthMonth = birth.getMonth() + 1;
    const birthDay = birth.getDate();
    let seasonBorn = "";
    for (const season of SEASONS) {
      if (season.name === "Musim Dingin") {
        if (birthMonth === 12 || birthMonth <= 3) {
          if (
            (birthMonth === 12 && birthDay >= 21) ||
            birthMonth < 3 ||
            (birthMonth === 3 && birthDay <= 20)
          ) {
            seasonBorn = season.name;
            break;
          }
        }
      } else {
        const inStartRange =
          birthMonth > season.start.month ||
          (birthMonth === season.start.month && birthDay >= season.start.day);
        const inEndRange =
          birthMonth < season.end.month ||
          (birthMonth === season.end.month && birthDay <= season.end.day);
        if (inStartRange && inEndRange) {
          seasonBorn = season.name;
          break;
        }
      }
    }
    // Life milestone
    let lifeMilestone = "";
    if (years < 1) lifeMilestone = "Bayi";
    else if (years < 3) lifeMilestone = "Balita";
    else if (years < 13) lifeMilestone = "Anak-anak";
    else if (years < 20) lifeMilestone = "Remaja";
    else if (years < 40) lifeMilestone = "Dewasa Muda";
    else if (years < 60) lifeMilestone = "Dewasa";
    else lifeMilestone = "Lansia";
    setAgeResult({
      years,
      months,
      days,
      hours: Math.abs(hours),
      minutes: Math.abs(minutes),
      seconds: Math.abs(seconds),
      totalDays,
      totalHours,
      totalMinutes,
      totalSeconds,
      totalWeeks,
      totalMonths,
      daysUntilBirthday,
      dayOfWeekBorn,
      birthMonthArabic,
      seasonBorn,
      lifeMilestone,
      heartbeats: Math.floor(totalDays * 100000),
      breaths: Math.floor(totalDays * 20000),
      sleepHours: Math.floor(totalHours / 3),
      mealsEaten: Math.floor(totalDays * 3),
    });
    setError(null);
  };
  const handleCalculate = () => {
    if (convertedValue === "gregorian") {
      if (!dateOfBirthGregorian.day || !dateOfBirthGregorian.month || !dateOfBirthGregorian.year) {
        setError("Harap masukkan tanggal lahir secara lengkap");
        return;
      }
      // Validate day based on month
      const day = parseInt(dateOfBirthGregorian.day);
      const month = parseInt(dateOfBirthGregorian.month);
      const year = parseInt(dateOfBirthGregorian.year);
      // Check for valid date
      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
      ) {
        setError("Tanggal lahir tidak valid");
        return;
      }
      // Create date string in YYYY-MM-DD format
      const dateString = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      calculateAge(dateString, false);
    } else {
      if (!dateOfBirthHijri.day || !dateOfBirthHijri.month || !dateOfBirthHijri.year) {
        setError("Harap masukkan tanggal lahir secara lengkap");
        return;
      }
      const hijriDay = parseInt(dateOfBirthHijri.day);
      const hijriMonth = parseInt(dateOfBirthHijri.month);
      const hijriYear = parseInt(dateOfBirthHijri.year);
      // Simple validation for Hijri date
      if (hijriDay < 1 || hijriDay > 30 || hijriMonth < 1 || hijriMonth > 12 || hijriYear < 1) {
        setError("Tanggal Hijriah tidak valid");
        return;
      }
      // Convert Hijri to Gregorian for calculation
      const gregorianDate = hijriToGregorian(hijriDay, hijriMonth, hijriYear);
      calculateAge(gregorianDate, true);
    }
  };
  // Get days in month for Hijri
  const getHijriDaysInMonth = (month) => {
    // Hijri months have 29 or 30 days
    const longMonths = [1, 3, 5, 7, 9, 11]; // Odd months are usually 30 days
    if (longMonths.includes(parseInt(month))) {
      return 30;
    }
    return 29; // Even months are usually 29 days
  };
  return (
    <div >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                Kalkulator usia Hijriah membantu Anda menghitung usia Hijriah dengan cepat dan akurat dalam kalender Hijriah dan Islam. Kalkulator mengembalikan tanggal yang dihitung dan menampilkan usia yang dihitung dalam tahun, bulan, hari, jam, menit, dan detik.
              </p>
              <ul> Untuk menghitung usia dalam tanggal Hijriah dengan akurat, kalkulator mengikuti langkah-langkah berikut:
                <li> Menentukan tanggal lahir seseorang: Anda harus mengetahui tanggal lahir orang yang ingin Anda hitung usianya dalam tanggal Hijriah
                </li>
                <li>Menghitung jumlah tahun: Mulailah dengan menghitung jumlah tahun antara tanggal lahir seseorang dan hari ini menggunakan kalender Hijriah.
                </li>
                <li>Mempertimbangkan bulan dan hari: Setelah menghitung tahun, pertimbangkan bulan dan hari Hijriah untuk mendapatkan usia yang akurat dalam tanggal Hijriah.
                </li>
              </ ul>
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                "Kalkulator Usia" dapat menentukan usia Hijriah. Usia yang dihitung akan ditampilkan dalam tahun, bulan, hari, jam, menit, dan detik. Hitung usia Anda dalam Hijriah dengan memasukkan tanggal lahir baik dalam tanggal Hijriah maupun Masehi - Gunakan kalkulator usia Hijriah untuk mengkonversi tanggal ke usia yang akurat sesuai kalender Hijriah.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds /> <hr />
            {/* Calculator Section */}
            <div className="calculatorStyle mb-3">
              <div className="p-3 mb-3 bg-success text-white rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>Hitung Usia Anda Sekarang</h2>
              </div>
              <div className="row">
                <div
                  className="form-group d-flex align-items-center"
                  style={{
                    columnGap: "25px",
                    margin: "5px 15px 25px 0",
                  }}
                >
                  <label >
                    <strong>Jenis Tanggal:</strong>
                  </label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="dateType"
                      id="gregorian"
                      value="gregorian"
                      checked={convertedValue === "gregorian"}
                      onChange={() => handleConversionValueChange("gregorian")}
                    />
                    <label className="form-check-label" htmlFor="gregorian">
                      Masehi
                    </label>
                  </div>

                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="dateType"
                      id="hijri"
                      value="hijri"
                      checked={convertedValue === "hijri"}
                      onChange={() => handleConversionValueChange("hijri")}
                    />
                    <label className="form-check-label" htmlFor="hijri">
                      Hijriah
                    </label>
                  </div>
                </div>
              </div>
              {convertedValue === "gregorian" ? (
                <div className="row">
                  <div className="col-md-12">
                    <label
                      htmlFor="dateOfBirth"
                      
                      style={{ fontSize: "16px" }}
                    >
                      Masukkan tanggal lahir Anda dalam kalender Masehi:
                    </label>
                    <div className="row">
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>Hari</label>
                        <select
                          className="form-control"
                          value={dateOfBirthGregorian.day || ""}
                          onChange={(e) => setDateOfBirthGregorian({ ...dateOfBirthGregorian, day: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Hari</option>
                          {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                            <option key={day} value={day}>{day}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>Bulan</label>
                        <select
                          className="form-control"
                          value={dateOfBirthGregorian.month || ""}
                          onChange={(e) => setDateOfBirthGregorian({ ...dateOfBirthGregorian, month: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Bulan</option>
                          {GREGORIAN_MONTHS.map((month, index) => (
                            <option key={index} value={index + 1}>{month}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>Tahun</label>
                        <select
                          className="form-control"
                          value={dateOfBirthGregorian.year || ""}
                          onChange={(e) => setDateOfBirthGregorian({ ...dateOfBirthGregorian, year: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Tahun</option>
                          {Array.from(
                            { length: new Date().getFullYear() - 1899 },
                            (_, i) => new Date().getFullYear() - i
                          ).map(year => (
                            <option key={year} value={year}>{year}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-md-12">
                    <label
                      htmlFor="hijriDatePicker"
                      
                      style={{ fontSize: "16px" }}
                    >
                      Masukkan tanggal lahir Anda dalam kalender Hijriah:
                    </label>
                    <div className="row">
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>Hari</label>
                        <select
                          className="form-control"
                          value={dateOfBirthHijri.day || ""}
                          onChange={(e) => {
                            setDateOfBirthHijri({ ...dateOfBirthHijri, day: e.target.value });
                          }}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Hari</option>
                          {dateOfBirthHijri.month ?
                            Array.from(
                              { length: getHijriDaysInMonth(dateOfBirthHijri.month) },
                              (_, i) => i + 1
                            ).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))
                            :
                            Array.from({ length: 30 }, (_, i) => i + 1).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))
                          }
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>Bulan</label>
                        <select
                          className="form-control"
                          value={dateOfBirthHijri.month || ""}
                          onChange={(e) => {
                            setDateOfBirthHijri({ ...dateOfBirthHijri, month: e.target.value, day: "" });
                          }}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Bulan</option>
                          {HIJRI_MONTHS.map((month, index) => (
                            <option key={index} value={index + 1}>{month}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>Tahun</label>
                        <select
                          className="form-control"
                          value={dateOfBirthHijri.year || ""}
                          onChange={(e) => setDateOfBirthHijri({ ...dateOfBirthHijri, year: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Tahun</option>
                          {hijriYears.map(year => (
                            <option key={year} value={year}>{year}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <br />
              <div className="text-center mb-3 mt-4">
                <button
                  className="btn btn-success"
                  onClick={handleCalculate}
                >
                  Hitung Usia Saya
                </button>
              </div>
              {error && (
                <div className="alert alert-warning" role="alert">
                  <strong>Peringatan:</strong> {error}
                </div>
              )}
              {ageResult && (
                <div
                  className="alert alert-success"
                  role="alert"
                  style={{ fontSize: "16px" }}
                >
                  <h3 style={{ fontSize: "20px", marginBottom: "15px" }}>
                    <strong>Hasil Perhitungan Usia:</strong>
                  </h3>
                  <div className="mb-3 p-3 bg-light rounded">
                    <strong style={{ fontSize: "18px" }}>Usia Anda:</strong>
                    <p style={{ fontSize: "17px", marginTop: "10px" }}>
                      {ageResult.years} tahun {ageResult.months} bulan{" "}
                      {ageResult.days} hari
                    </p>
                  </div>
                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Usia Anda Secara Detail</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>✓ Tahun: {ageResult.years}</li>
                          <li>✓ Bulan: {ageResult.months}</li>
                          <li>✓ Hari: {ageResult.days}</li>
                          <li>✓ Jam: {ageResult.hours}</li>
                          <li>✓ Menit: {ageResult.minutes}</li>
                          <li>✓ Detik: {ageResult.seconds}</li>
                        </ul>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Statistik Total</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>
                            📅 Total Hari yang Dijalani:{" "}
                            {ageResult.totalDays.toLocaleString()} hari
                          </li>
                          <li>
                            📅 Total Minggu:{" "}
                            {ageResult.totalWeeks.toLocaleString()} minggu
                          </li>
                          <li>
                            📅 Total Bulan:{" "}
                            {ageResult.totalMonths.toLocaleString()} bulan
                          </li>
                          <li>
                            ⏰ Total Jam:{" "}
                            {ageResult.totalHours.toLocaleString()} jam
                          </li>
                          <li>
                            ⏰ Total Menit:{" "}
                            {ageResult.totalMinutes.toLocaleString()} menit
                          </li>
                          <li>
                            ⏰ Total Detik:{" "}
                            {ageResult.totalSeconds.toLocaleString()} detik
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Informasi Menarik tentang Hidup Anda</strong>
                      </div>
                      <div className="info-section-body">
                        <h4 style={{ fontSize: "16px", marginBottom: "10px" }}>
                          Informasi Umum:
                        </h4>
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>🗓️ Anda lahir pada hari: {ageResult.dayOfWeekBorn}</li>
                          <li>📅 Pada bulan: {ageResult.birthMonthArabic}</li>
                          <li>🌸 Pada musim: {ageResult.seasonBorn}</li>
                          <li>
                            🎂 Hari tersisa hingga ulang tahun Anda berikutnya:{" "}
                            {ageResult.daysUntilBirthday} hari
                          </li>
                          <li>👤 Tahap kehidupan: {ageResult.lifeMilestone}</li>
                        </ul>
                        <h4
                          style={{
                            fontSize: "16px",
                            marginTop: "15px",
                            marginBottom: "10px",
                          }}
                        >
                          Fakta Menakjubkan yang Terjadi dalam Hidup Anda (Perkiraan):
                        </h4>
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>
                            💓 Detak jantung Anda sekitar:{" "}
                            {ageResult.heartbeats.toLocaleString()} kali
                          </li>
                          <li>
                            🫁 Anda bernapas sekitar:{" "}
                            {ageResult.breaths.toLocaleString()} napas
                          </li>
                          <li>
                            😴 Anda menghabiskan waktu tidur sekitar:{" "}
                            {ageResult.sleepHours.toLocaleString()} jam (
                            {Math.floor(ageResult.sleepHours / 24).toLocaleString()}{" "}
                            hari)
                          </li>
                          <li>
                            🍽️ Anda makan sekitar:{" "}
                            {ageResult.mealsEaten.toLocaleString()} porsi
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>

      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Usia dalam Tanggal Hijriah: Panduan Lengkap untuk Menghitung Usia dengan Akurat Menurut Kalender Hijriah
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Usia dalam Tanggal Hijriah: Konversi dan Perhitungan Akurat{" "}
                  </h2>{" "}
                </u>
                <p>
                  Karya peradaban dan tradisi budaya adalah aspek terpenting yang membedakan berbagai budaya di seluruh dunia. Di antara budaya yang paling menonjol yang memiliki kalender waktu sendiri adalah kalender Hijriah, yang digunakan secara luas di dunia Islam. Dalam artikel ini, kita akan membahas topik menghitung usia dalam tanggal Hijriah dan bagaimana mengkonversi tanggal ke usia Hijriah dengan akurat.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}> Konsep Usia Hijriah </h2>{" "}
                </u>
                <p>
                  Usia Hijriah adalah cara di mana usia seseorang dihitung menggunakan kalender Hijriah. Jenis perhitungan ini didasarkan pada tahun Hijriah, bulan Hijriah, dan hari Hijriah. Metode ini terutama digunakan di dunia Islam untuk menghitung usia dan menentukan acara keagamaan dan perayaan.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Cara Menghitung Usia dalam Tanggal Hijriah{" "}
                  </h2>{" "}
                </u>
                Untuk menghitung usia dalam tanggal Hijriah dengan akurat, Anda harus mengikuti langkah-langkah berikut:
                <ul>
                  <li>
                    Menentukan tanggal lahir seseorang: Anda harus mengetahui tanggal lahir orang yang ingin Anda hitung usianya dalam tanggal Hijriah.
                  </li>
                  <li>
                    Menghitung jumlah tahun: Mulailah dengan menghitung jumlah tahun antara tanggal lahir seseorang dan hari ini menggunakan kalender Hijriah.
                  </li>
                  <li>
                    Mempertimbangkan bulan dan hari: Setelah menghitung tahun, pertimbangkan bulan dan hari Hijriah untuk mendapatkan usia yang akurat dalam tanggal Hijriah.
                  </li>
                </ul>
                <p></p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Menggunakan Kalkulator Usia Hijriah yang Akurat{" "}
                  </h2>{" "}
                </u>
                <p>
                  Untuk memudahkan proses menghitung usia dalam tanggal Hijriah, Anda dapat menggunakan kalkulator usia Hijriah yang akurat. Alat ini mengkonversi tanggal lahir ke usia Hijriah dengan cepat dan akurat. Yang perlu Anda lakukan adalah memasukkan tanggal lahir, dan kalkulator akan memberikan hasil secara instan.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Kegunaan Menghitung Usia dalam Tanggal Hijriah{" "}
                  </h2>{" "}
                </u>
                <p>
                  Perhitungan usia dalam tanggal Hijriah digunakan dalam banyak konteks di dunia Islam. Ini dapat digunakan untuk menentukan hari raya dan acara keagamaan seperti Ramadhan dan Idul Fitri, serta untuk menghitung usia dalam dokumen resmi dan lisensi.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Bagaimana Kalkulator Usia Hijriah Bekerja{" "}
                  </h2>{" "}
                </u>
                <p>
                  Penggunaan kalender Hijriah untuk menghitung usia manusia berasal dari sejarah Islam. Kalender Hijriah didasarkan pada hijrah Nabi Muhammad SAW dari Mekah ke Madinah pada tahun 622. Tahun Hijriah terdiri dari 12 bulan, dan jumlah hari setiap bulan bervariasi menurut kalender Hijriah. Tahun Hijriah lebih pendek dari tahun Masehi, sehingga tanggalnya berbeda dalam kedua tahun. <br />
                </p>
                <p>
                  Usia manusia dalam kalender Hijriah didasarkan pada tanggal lahir mereka dan tanggal saat ini dalam kalender Hijriah. Usia dapat dihitung dalam tahun, bulan, hari, jam, menit, dan detik. <br />
                </p>
                <p>
                  Namun, saya harus menjelaskan bahwa usia yang tepat dalam kalender Hijriah tergantung pada waktu saat ini dan tanggal Hijriah pada saat kode dijalankan. Jika kode dijalankan pada waktu tertentu, itu akan memberi Anda usia saat ini sesuai dengan tanggal itu. <br />
                </p>
                <p>
                  Misalnya, jika hari ini adalah 27 Mei 2023 dan tanggal lahir adalah 1 Muharram 1421, maka usia akan dihitung berdasarkan perbedaan waktu dan tanggal Hijriah ini. <br />
                </p>
                <p></p>
                <p></p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>Pertanyaan Umum</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Apa itu usia Hijriah?</h3>
              </div>
              <div className="info-section-body">
                Usia Hijriah adalah cara yang kita gunakan untuk mengukur usia seseorang menggunakan kalender Hijriah, yaitu kalender yang digunakan di dunia Islam.
                <br />
                <label>
                  Sumber:{" "}
                  <a href="https://ar.wikipedia.org/wiki/%D8%AA%D9%82%D9%88%D9%8A%D9%85_%D9%87%D8%AC%D8%B1%D9%8A">
                    Wikipedia
                  </a>
                </label>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara menghitung usia Hijriah?
                </h3>
              </div>
              <div className="info-section-body">
                Anda dapat menghitung usia Hijriah dengan mudah dengan mengikuti langkah-langkah ini:
                <ol>
                  <li>Tentukan tanggal lahir.</li>
                  <li>
                    Hitung jumlah tahun antara tanggal lahir dan hari ini menggunakan kalender Hijriah.
                  </li>
                  <li>Pertimbangkan bulan dan hari Hijriah untuk mendapatkan usia yang akurat.</li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah ada kalkulator untuk menghitung usia Hijriah?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, ada banyak kalkulator online yang membantu Anda menghitung usia Hijriah dengan akurat. Yang perlu Anda lakukan adalah memasukkan tanggal lahir, dan kalkulator akan mengkonversinya ke usia Hijriah secara otomatis.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa saja kegunaan usia Hijriah?
                </h3>
              </div>
              <div className="info-section-body">
                Usia Hijriah umumnya digunakan di dunia Islam untuk menentukan hari raya dan acara keagamaan seperti Ramadhan dan Idul Fitri. Ini juga digunakan dalam lisensi pernikahan dan dokumen resmi.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bisakah usia Hijriah dihitung secara manual?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, usia Hijriah dapat dihitung secara manual menggunakan aturan Masehi yang dikenal. Cukup hitung tahun antara tanggal lahir dan hari ini dalam Hijriah dan kemudian pertimbangkan bulan dan hari.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa pentingnya menghitung usia Hijriah?
                </h3>
              </div>
              <div className="info-section-body">
                Perhitungan usia Hijriah sangat penting di dunia Islam, karena digunakan untuk menentukan tanggal keagamaan dan syariah serta memantau peristiwa keagamaan. Ini juga digunakan dalam dokumen resmi, kontrak, dan untuk tujuan lisensi.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AgeCalculatorHijri;